module.exports = __webpack_public_path__ + "img/grazing-table.329b8ffc.webp";